import debounce from "../utils/debounce";

export default class MapFeature {
  constructor(elem) {
    this.elem = elem;
    this.stats = this.elem.querySelectorAll(".js-mf-stat");
    this.deviceType = null;
    this.previousDeviceType = null;
    this.interval = null;
  }

  setupIndicatorAnimation() {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.setInterval();
        observer.disconnect();
      }
    });

    observer.observe(this.elem);
  }

  setInterval() {
    this.interval = setInterval(() => {
      const selectedStat = this.elem.querySelector(".selected");
      const nextStat = selectedStat.nextElementSibling || this.stats[0];
      selectedStat.classList.remove("selected");
      nextStat.classList.add("selected");
    }, 2000);
  }

  deviceEventController() {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const isDesktop = window.matchMedia('(min-width: 768px)').matches;

    if (isMobile) {
      this.deviceType = 'mobile';
      if (this.previousDeviceType === this.deviceType) return;
      // mobile setup, desktop teardown
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
    if (isDesktop) {
      this.deviceType = 'desktop';
      if (this.previousDeviceType === this.deviceType) return;
      // desktop setup, mobile teardown
      this.setupIndicatorAnimation();

    }

    this.previousDeviceType = isMobile ? 'mobile' : 'desktop';
  }


  init() {
    this.deviceEventController();
    window.addEventListener("resize", debounce(this.deviceEventController.bind(this), 200));
  }
}
